// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Resources-module_resource_list_table_tOUNA {
  width: 100%;
  border-spacing: 8px 10px;
  border-collapse: unset;
}

.Resources-module_resource_list_table_tOUNA,
.Resources-module_account_list_table_compact_DJb_V td {
  vertical-align: middle;
}

.Resources-module_table_header_cell_OIDQj {
  text-align: center;
  vertical-align: bottom;
  font-weight: 600;
}

.Resources-module_resource_lookup_box_Ja3Qf {
  position: relative;
  padding: 20px 32px;
  margin: 16px 24px 28px;
  border: 1px solid var(--primary-bos-color);
}

.Resources-module_resource_lookup_button_jIUP9 {
  cursor: pointer;
}

.Resources-module_resource_lookup_close_box_IIOce {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: white;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Resources/Resources.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":[".resource_list_table {\n  width: 100%;\n  border-spacing: 8px 10px;\n  border-collapse: unset;\n}\n\n.resource_list_table,\n.account_list_table_compact td {\n  vertical-align: middle;\n}\n\n.table_header_cell {\n  text-align: center;\n  vertical-align: bottom;\n  font-weight: 600;\n}\n\n.resource_lookup_box {\n  position: relative;\n  padding: 20px 32px;\n  margin: 16px 24px 28px;\n  border: 1px solid var(--primary-bos-color);\n}\n\n.resource_lookup_button {\n  composes: primary_button_minimal from 'Styles/styles.module.css';\n  cursor: pointer;\n}\n\n.resource_lookup_close_box {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background-color: white;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resource_list_table": `Resources-module_resource_list_table_tOUNA`,
	"account_list_table_compact": `Resources-module_account_list_table_compact_DJb_V`,
	"table_header_cell": `Resources-module_table_header_cell_OIDQj`,
	"resource_lookup_box": `Resources-module_resource_lookup_box_Ja3Qf`,
	"resource_lookup_button": `Resources-module_resource_lookup_button_jIUP9 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_minimal"]}`,
	"resource_lookup_close_box": `Resources-module_resource_lookup_close_box_IIOce`
};
export default ___CSS_LOADER_EXPORT___;
